import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";

import { useSelector } from "react-redux";
import more from '../../../constants/images/more.svg';
import { MAIN_ROUTES } from "../../../routing/main_routes";
import { applicationService } from "../../../services/application.service";
import DetailedOptions from "../../DetailedOptions/DetailedOptions";
import styles from './OrderItem.module.scss';

const OrderItem = ({order, handleDeleteOrder, type}) => {
    const {pk: id, get_total_price, created_on, service_package, request_price, status} = order;
    const isExpired = status === 'EXPIRED';
    const [cleanerApplications, setCleanerApplications] = useState();
    const [isApprovedOfferByCleaner, setIsApprovedOfferByCleaner] = useState(false);
    const [currentOrder, setCurrentOrder] = useState();

    const [isDetailedOptionsVisible, setIsDetailedOptionsVisible] = useState(false);

    const { ordersByCurrentUser } = useSelector(state => state.order);

    const navigate = useNavigate();

    useEffect(() => {
        const getCleanerApplicationsByCleaningRequest = async () => {
            try {
                const res = await applicationService.getByRequest(id);

                setCleanerApplications(res?.data?.count);
            } catch (error) {
                console.error(error)
            }
        }

        getCleanerApplicationsByCleaningRequest();

        setIsApprovedOfferByCleaner(ordersByCurrentUser.find((item) => item.offer.application.request.pk === id));
        setCurrentOrder(ordersByCurrentUser.find((item) => item.offer.application.request.pk === id));
    }, []);

    const handleNavigateToDetailsOrderPage = () => {
        navigate(`${MAIN_ROUTES.ORDER_DETAILS}/${id}`, {
            state: {
                step: cleanerApplications > 0 ? 'step2' : null,
                type,
                id: currentOrder?.offer?.order
            }
        });
    }

    return (
        <div className={styles.orderItem_wrapper}>
            <div
                onClick={handleNavigateToDetailsOrderPage}
                className={styles.orderItem_wrapper_content}
            >
                <div className={styles.orderItem_wrapper_content_titleContainer}>
                    <h2 className={styles.orderItem_wrapper_content_titleContainer_title}>{service_package?.name}</h2>

                    <div className={styles.row}>
                        {isExpired &&
                            <span className={styles.expiredBadge}>Прострочено</span>}

                        {currentOrder?.to_client_feedback &&
                            <button
                                onClick={(event) => {
                                    event.stopPropagation();
                                    navigate(`${MAIN_ROUTES.ORDER_DETAILS}/${id}`, {
                                        state: {
                                            step: cleanerApplications > 0 ? 'step3' : null,
                                            type
                                        }
                                    });
                                }}
                                className={styles.buttonDesktop}
                            >Очікуєм на Ваш відгук</button>}

                        <div
                            onClick={(event) => {
                                event.stopPropagation();
                                setIsDetailedOptionsVisible(true);
                            }}
                            onMouseLeave={() => setIsDetailedOptionsVisible(false)}
                            className={styles.orderItem_wrapper_content_titleContainer_more}
                        >
                            <img src={more} alt="detailed info icon"/>
                            {
                                isDetailedOptionsVisible ?
                                    <DetailedOptions
                                        type={type}
                                        id={id}
                                        setIsDetailedOptionsVisible={setIsDetailedOptionsVisible}
                                        handleDeleteOrder={handleDeleteOrder}
                                        isApprovedOfferByCleaner={isApprovedOfferByCleaner}
                                    /> :
                                    null
                            }
                        </div>
                    </div>
                </div>

                <div className={styles.orderItem_wrapper_content_details}>
                    <div className={styles.orderItem_wrapper_content_details_leftSide}>
                        <p className={styles.text}>Оплата - <span>₴ {+request_price || get_total_price}</span></p>
                        <p className={styles.text}>{new Date(created_on).toLocaleDateString()}</p>
                    </div>

                    <div className={styles.orderItem_wrapper_content_details_rightSide}>
                        <div className={styles.orderItem_wrapper_content_details_rightSide_block}>
                            <p className={styles.count}>{cleanerApplications || 0}</p>
                            <p className={styles.text}>Пропозицій</p>
                        </div>

                        <div className={styles.orderItem_wrapper_content_details_rightSide_block}>
                            <p className={styles.count}>{isApprovedOfferByCleaner ? 1 : 0}</p>
                            <p className={styles.text}>Прийнято</p>
                        </div>
                    </div>
                </div>
                
                {currentOrder?.to_client_feedback &&
                    <button
                        onClick={(event) => {
                            event.stopPropagation();
                            navigate(`${MAIN_ROUTES.ORDER_DETAILS}/${id}`, {
                                        state: {
                                            step: cleanerApplications > 0 ? 'step3' : null,
                                            type
                                        }
                            });
                        }}
                        className={styles.buttonMobile}
                    >Очікуєм на Ваш відгук</button>}
            </div>
        </div>
    );
};


export default OrderItem;
